import { BbanStructure } from 'ibankit';

export const hasIbanSupport = (status?: string, addressCountryCode?: string | null): boolean => {
  if (status === 'SHUE' && addressCountryCode) {
    const structure = BbanStructure.forCountry(addressCountryCode);
    return structure != null;
  }

  return true;
};
